<div class="diashow__container">
  <div class="image__container">
    @for (image of this.DIASHOW_ITEMS; track $index) {
      <img [src]="image.image"
           [class.active]="$index === this.currentDiashowIndex()"
           [alt]="image.alt"/>
    }
  </div>
		@for (item of this.DIASHOW_ITEMS; track $index) {
  <div [ngClass]="{infobox__container: true, active: $index === this.currentDiashowIndex()}">
    <h3 class="mat-headline-small">{{ item.translationInfoName.defaultText | translate : item.translationInfoName.token}}</h3>
					<p class="mat-body-large" appTextClamp [text]="item.translationInfoDescription.defaultText| translate : item.translationInfoDescription.token"></p>
    <a mat-flat-button class="learn-more-button mat-label-large" target="_blank" [href]="item.url">{{"Mehr erfahren" | translate : "action-learn-more" }}</a>
  </div>
	}
</div>
<div class="control__container">
  <ogs-m3-icon icon="chevron-left" class="navigation-arrow" (click)="this.previousDiashowItem()"/>
  <div class="dots__container">
    @for (image of this.DIASHOW_ITEMS; track $index) {
      <div class="dot" (click)="this.setDiashowItemByIndex($index)" [class.active]="this.currentDiashowIndex() === $index"></div>
    }
  </div>
  <ogs-m3-icon icon="chevron-right" class="navigation-arrow" (click)="this.nextDiashowItem()"/>
</div>

